<button
    [id]="id() + '-trigger'"
    [attr.data-testid]="currentTestId() + '-trigger'"
    [attr.data-styletarget]="id() + '-trigger'"
    [attr.data-uitype]="'trigger'"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    class="iq-md iq-md-icon-label cargo-chip font-body-2 bg-white"
    [attr.data-styleDisabled]="isDisabled()"
    [attr.data-styleEdited]="isEdited()"
    [attr.data-styleOpened]="isOpened()"
    [attr.data-styleClosed]="!isOpened()"
    [class.border-dat-blue-500]="isEdited()"
    [class.border-dat-grey-200]="!isEdited()"
    (click)="openPanel()"
>
    <div [class.hidden]="isOpened()">
        <iq-builder-label
            [label]="openLabel()"
            [type]="'html'"
        ></iq-builder-label>
    </div>
    <div [class.hidden]="!isOpened()">
        <iq-builder-label
            [label]="closedLabel()"
            [type]="'html'"
        ></iq-builder-label>
    </div>
</button>
<ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayPush
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpened()"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayDisableClose]="true"
    (overlayOutsideClick)="outsideClick()"
    #overlay="cdkConnectedOverlay"
>
    <ng-container *ngTemplateOutlet="panelTemplate"></ng-container>
</ng-template>

<ng-template #panelTemplate>
    <iq-style-processor-css-class [classNames]="panelClasses()">
        <div
            [id]="id() + '-panel'"
            [attr.data-testid]="currentTestId() + '-panel'"
            [attr.data-styletarget]="id() + '-panel'"
            [attr.data-uitype]="'panel'"
            (document:keydown.escape)="pressEscape()"
            class="bg-white p-4 cargo-shadow-dropdown-menu"
        >
            <iq-controls-control-panel-form
                [id]="formId()"
                [attr.data-testid]="currentTestId() + '-form'"
                [attr.data-styletarget]="formId()"
                [attr.data-uitype]="'form'"
                [classes]="formClasses()"
                [controls]="currentControls()"
                [fg]="panelFg"
                (changed)="change('value', $event)"
                (clicked)="click('value', $event)"
                (submitted)="submit('value', $event)"
                [isEdited]="isEdited()"
            ></iq-controls-control-panel-form>
        </div>
    </iq-style-processor-css-class>
</ng-template>
